import { gql } from '@apollo/client';

const RMA_OPTIONS_QUERY = gql`
  query rmaOptions($category: String!, $deviceModel: String) {
    rmaOptions(catalog: "RMA_INFO", category: $category, deviceModel: $deviceModel) {
      value
      label
      group
      needsDescribe
    }
  }
`;

export default RMA_OPTIONS_QUERY;
